import React from "react";
import moment from "moment";
import { ApprovalDateRangeFilter } from "components/CustomComponents/ApprovalDateRangeFilter";
import { resolvePresetLabel } from "components/CustomComponents/dateRangeDefaults";
import { eventTraceDateField } from "./eventTraceConfig";

export function EventTraceDateRangeFilter({ table }) {
  const dateField = eventTraceDateField(table.state);
  const receivedRange = dateField === "received_at";
  const from = table.state[`${dateField}_from`] || (receivedRange ? table.state.start_date : null);
  const to = table.state[`${dateField}_to`] || (receivedRange ? table.state.end_date : null);
  const endDate = to || from || moment().format("YYYY-MM-DD");
  const startDate = from || to || moment().subtract(6, "days").format("YYYY-MM-DD");
  const allDates = table.state.event_time === "all" && !from && !to;
  const displayLabel = allDates ? "All dates" : from && !to
    ? `From ${moment(from).format("DD-MM-YYYY")}` : to && !from
      ? `Until ${moment(to).format("DD-MM-YYYY")}` : undefined;
  return <ApprovalDateRangeFilter
    startDate={startDate} endDate={endDate}
    dateRangeLabel={resolvePresetLabel(startDate, endDate)} displayLabel={displayLabel}
    showToday includeCurrentDate thisMonthToDate allowFutureDate={false}
    onChange={(start, end) => table.setParams({
      ...(receivedRange ? { start_date: null, end_date: null } : { event_time: null }),
      [`${dateField}_from`]: moment(start).format("YYYY-MM-DD"), [`${dateField}_to`]: moment(end).format("YYYY-MM-DD") })}
    sx={{ minHeight: 46, maxWidth: "100%" }}
  />;
}
